import { render, staticRenderFns } from "./spaceHeader.vue?vue&type=template&id=402d8656&scoped=true"
import script from "./spaceHeader.vue?vue&type=script&lang=js"
export * from "./spaceHeader.vue?vue&type=script&lang=js"
import style0 from "./spaceHeader.vue?vue&type=style&index=0&id=402d8656&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402d8656",
  null
  
)

export default component.exports